import { defineStore } from "pinia";
import { testDummy, testNew, tipos, estados, privacidades, usos }  from "../data/test";

import axios from 'axios';
import AxiosHelper from '../utils/axios_helper'; //CSRF

export const useTestStore = defineStore( "TestStore", {
  
  //state
  state: () => {
    return {
      test: [],
      inputPoster: null, 
      tipos,
      //categorias,
      estados,
      privacidades,
      usos,
      test_changed: false,
      test_changed_by_axios: false, //El watcher también detecta los cambios por axios
    }
  },
  
  actions: {

    /**
     * Init test
     */

    new_test(categoria_id) {
      this.test = testNew;
      this.test.categoria_id = categoria_id;
    }, 

    edit_test(test) {
      this.test = test;
    }, 

    do_test_changed() {
      this.test_changed = true;
      if(this.test_changed_by_axios) {
        this.test_changed = false;
        this.test_changed_by_axios = false;
      }
    },



    /**
     * API
     */

    save_test() {
      if (!this.test_changed) return;

      // Algunas comprobaciones
      this.pon_puntuaciones_min_max_dimensiones();
      

      this.test.id ? this.update_test() : this.create_test();
    },

    async create_test() {
      //CSRF
      AxiosHelper();
      
      try {
        const response = await axios.post("/tests.json", { test: this.test});
        //Ponemos el id, que es el dato nuevo.
        if(response.statusText == "Created") {

          this.test_changed_by_axios = true; //Utilizado por el watcher
          this.test.id = response.data.test.id;
          this.test.user = response.data.test.user;
          this.test_changed = false;
        }
        
      } catch (error){ 
        console.log(error);
      }
    },

    async update_test() {
      //CSRF
      AxiosHelper();

      
      try {
        const response = await axios.put("/tests/"+this.test.id+".json", { test: this.test});
        
        if(response.statusText == "OK") {
          this.test_changed = false;
        }
        
      } catch (error){ 
        console.log(error);
      }
    },

    async upload_poster() {
    
      //CSRF
      AxiosHelper();

      let formData = new FormData();
      formData.append("poster", this.inputPoster);
      
      try {
        const response = await axios.put("/tests/"+this.test.id+"/poster.json", formData);
        

        if(response.statusText == "OK") {
          this.inputPoster = null;
        }
        
      } catch (error){ 
        console.log(error);
      }
    },

    async delete_poster() {
      //CSRF
      AxiosHelper();
      
      try {
        const response = await axios.delete("/tests/"+this.test.id+"/poster.json", { payload: "eliminar"});
        
        if(response.statusText == "OK") {
          this.test.poster = null;
          
        }
        
      } catch (error){ 
        console.log(error);
      }
    },

    async delete_test() {
      //CSRF
      AxiosHelper();
      try {
        const response = await axios.delete("/tests/"+this.test.id+".json", {payload: "payload"});
        if(response.statusText == "No Content") {
          window.location.href = '/tests';
        }
      } catch (error){ 
        console.log(error);
      }
    },


    /**
     * Add
     */

    add_dimension() {
      
      //Creamos el id. Le pongo los "..." porque el map devuelve un array, y Math.max necesita parámetros
      const id = Math.max(...this.test.dimensiones.map((dim) => dim.id), 0)+1;
      
      // Añado la dimensión nueva
      const dimension = {
        "id": id, 
        "nombre": "", 
        "descripcion": "", 
        "puntos_min": 0,
        "puntos_max": 10,
        "diagnosticos": []
      }
      
      this.test.dimensiones.push(dimension);
    },

    add_seccion() {
      
      //Creamos el id. Le pongo los "..." porque el map devuelve un array, y Math.max necesita parámetros
      const id = Math.max(...this.test.secciones.map((dim) => dim.id), 0)+1;
      
      // Añado la dimensión nueva
      const seccion = {
        "id": id, 
        "nombre": "", 
        "descripcion": "",
        "dimension_id": null
      }
      
      this.test.secciones.push(seccion);
    },

    add_leyenda(seccion_id) {
      
      //Creamos el id. Le pongo los "..." porque el map devuelve un array, y Math.max necesita parámetros
      const id = Math.max(...this.test.leyendas.map((dim) => dim.id), 0)+1;
      
      // Añado la dimensión nueva
      const leyenda = {
        "id": id, 
        "seccion_id": seccion_id,
        "text": "",
        "longitud": "",
        "alineacion": "left",        
      }
      
      this.test.leyendas.push(leyenda);
    },


    add_respuesta(seccion_id) {
      
      console.log(seccion_id);
      //Creamos el id. Le pongo los "..." porque el map devuelve un array, y Math.max necesita parámetros
      const id = Math.max(...this.test.respuestas.map((dim) => dim.id), 0)+1;
      
      const respuesta = {
        "id": id, 
        "seccion_id": seccion_id,
        "pregunta_id": null,
        "text": "",
        "puntos": 1,
        "puntos_inverso": 1,
      }
      
      this.test.respuestas.push(respuesta);
    },

    add_pregunta(seccion) {
      
      //Creamos el id. Le pongo los "..." porque el map devuelve un array, y Math.max necesita parámetros
      const id = Math.max(...this.test.preguntas.map((dim) => dim.id), 0)+1;
      
      let seccion_id, dimension_id, ultima_pregunta;
      if(seccion == undefined) {
        ultima_pregunta = this.test.preguntas[this.test.preguntas.length -1];
        seccion_id = ultima_pregunta.seccion_id;
        dimension_id = ultima_pregunta.dimension_id;
      }else{
        seccion_id = seccion.id;
        dimension_id = dimension.id;
      }

      const pregunta = {
        "id": id, 
        "seccion_id": seccion_id,
        "dimension_id": dimension_id,
        "text": "",
        "modo_puntuacion": "directo",
        "peso": 1
      }
      
      this.test.preguntas.push(pregunta);
    },

    toggle_filtro(filtro) {
      const index = this.test.filtros.findIndex((fil) => fil.id == filtro.id);
      //Cogemos solo campos que queremos del filtro
      const filtro_light = {
        id: filtro.id,
        default: filtro.user_id == null,
        tipo: filtro.tipo,
        nombre: filtro.nombre,
        field_db: filtro.field_db,
        integer_values: filtro.integer_values,
        select_values: filtro.select_values
      }
  
      if(index > -1){
        this.test.filtros.splice(index, 1);
      } else {
        this.test.filtros.push(filtro_light)
      }
    },

    /**
     * Delete
     */

    delete_dimension(dimension_id) {
      const index = this.test.dimensiones.findIndex((item) => item.id == dimension_id);
      this.test.dimensiones.splice(index, 1);
    },

    delete_seccion(seccion_id) {
      // Si la sección tiene preguntas, respuetas o leyendas, no podemos borrarla
      if(this.preguntas_seccion(seccion_id).length > 0) return;
      if(this.respuestas_seccion(seccion_id).length > 0) return;
      if(this.leyendas_seccion(seccion_id).length > 0) return;
      
      const index = this.test.secciones.findIndex((item) => item.id == seccion_id);
      this.test.secciones.splice(index, 1);
    },

    delete_leyenda(leyenda_id) {
      const index = this.test.leyendas.findIndex((item) => item.id == leyenda_id);
      this.test.leyendas.splice(index, 1);
    },

    delete_respuesta(respuesta_id) {
      const index = this.test.respuestas.findIndex((item) => item.id == respuesta_id);
      this.test.respuestas.splice(index, 1);
    },

    delete_pregunta(pregunta_id) {
      const index = this.test.preguntas.findIndex((item) => item.id == pregunta_id);
      this.test.preguntas.splice(index, 1);
    },

    // Intercambia la posición de dos elementos de un array
    // Código muestra: 
    // const droppedItem = testStore.dimensiones.splice(draggedItem.value, 1)[0]
    // testStore.dimensiones.splice(index, 0, droppedItem)
    
    aux_cambia_posicion(arr, from, to) {
      arr.splice(to, 0, arr.splice(from, 1)[0])
    },

    // Colocamos las puntuaciones mínimas y máximas de las dimensiones de forma automática
    pon_puntuaciones_min_max_dimensiones() {
      // Necesitamos una biblioteca con todas las puntuaciones min y max.
      // Inicializamos la biblioteca
      let respuestas_min_max = {}

      
      // Test tipo == 1. Misma respuestas para todas las secciones
      respuestas_min_max[0] = {}
      respuestas_min_max[0].min = null;
      respuestas_min_max[0].max = null;
      respuestas_min_max[0].min_inverso = null;
      respuestas_min_max[0].max_inverso = null;
      
      // Test tipo == 2. Diferentes respuestas por sección
      this.test.secciones.forEach(seccion => {
        respuestas_min_max[seccion.id] = {}
        respuestas_min_max[seccion.id].min = null;
        respuestas_min_max[seccion.id].max = null;
        respuestas_min_max[seccion.id].min_inverso = null;
        respuestas_min_max[seccion.id].max_inverso = null;
      });

      this.test.respuestas.forEach(respuesta => {

        if(respuestas_min_max[respuesta.seccion_id].min == null || 
          respuestas_min_max[respuesta.seccion_id].min > respuesta.puntos ) { 
            respuestas_min_max[respuesta.seccion_id].min = respuesta.puntos; 
        }

        if(respuestas_min_max[respuesta.seccion_id].max == null ||
            respuestas_min_max[respuesta.seccion_id].max < respuesta.puntos ) { 
          respuestas_min_max[respuesta.seccion_id].max = respuesta.puntos; 
        }

        if(respuestas_min_max[respuesta.seccion_id].min_inverso == null ||
            respuestas_min_max[respuesta.seccion_id].min_inverso > respuesta.puntos_inverso ) { 
          respuestas_min_max[respuesta.seccion_id].min_inverso = respuesta.puntos_inverso; 
        }

        if(respuestas_min_max[respuesta.seccion_id].max_inverso == null ||
            respuestas_min_max[respuesta.seccion_id].max_inverso < respuesta.puntos_inverso ) { 
          respuestas_min_max[respuesta.seccion_id].max_inverso = respuesta.puntos_inverso; 
        }
      });

      // Una vez creada la biblioteca, puntuamos cada dimensión.
      this.test.dimensiones.forEach(dimension => {
        
        let dimension_puntos_min = 0;
        let dimension_puntos_max = 0;

        // Cogemos todas las preguntas asociadas a esa dimensión
        this.test.preguntas.filter(p => p.dimension_id == dimension.id).forEach(pregunta => {
                    
          //Para cada pregunta, miramos sus respuestas posibles. 

          //Si el tipo es 1. Fácil
          //Respuestas iguales para todas las secciones

          let seccion_id = 0;
          if(this.test.tipo != 1){
            seccion_id = pregunta.seccion_id;
          }


          if(pregunta.modo_puntuacion == "directo") {
            dimension_puntos_min += pregunta.peso*respuestas_min_max[seccion_id].min;
            dimension_puntos_max += pregunta.peso*respuestas_min_max[seccion_id].max;
          }else{
            dimension_puntos_min += pregunta.peso*respuestas_min_max[seccion_id].min_inverso;
            dimension_puntos_max += pregunta.peso*respuestas_min_max[seccion_id].max_inverso;
          }
          
        });
        
        dimension.puntos_min = dimension_puntos_min;
        dimension.puntos_max = dimension_puntos_max;
    
      });

    }

  },

  getters: {

    dimensiones: (state) => { return state.test.dimensiones },
    
    secciones: (state) => { return state.test.secciones },

    preguntas: (state) => { return state.test.preguntas },

    respuestas: (state) => { return state.test.respuestas },
    
    leyendas: (state) => { return state.test.leyendas },

    preguntas_seccion: (state) => {
      return (seccion_id) => state.test.preguntas.filter((pre) => pre.seccion_id === seccion_id)
    },

    respuestas_seccion: (state) => {
      return (seccion_id) => state.test.respuestas.filter((res) => res.seccion_id === seccion_id)
    },

    leyendas_seccion: (state) => {
      return (seccion_id) => state.test.leyendas.filter((res) => res.seccion_id === seccion_id)
    },

    filtro_id: (state) => {
      return (id) => state.test.filtros.filter((fil) => fil.id === id)
    },

  },


})















// await axios.post("/tests.json", {
      //   test: this.test,
      // })
      // .then(function (response) {
      //   console.log(response);
      //   console.log(response.data);       // `data` es la respuesta provista por el servidor
      //   console.log(this);
      //   //console.log(response.status);     // `status` es el código HTTP de la respuesta del servidor
      //   //console.log(response.statusText); // `statusText` es el mensaje del estado HTTP de la respuesta del servidor                                          
      //   //console.log(response.headers);    // Todos los nombres de cabeceras son convertidos a minúsculas y pueden ser accedidos usando la notación de corchetes.
      //                                     // Ejemplo: `response.headers['content-type']`
      //   //console.log(response.config);     // `config`  es la configuración provista a `axios` por la petición
      //   //console.log(response.request);    // `request` es la petición que genera esta respuesta,
      // })
      // .catch(function (error) {

      //   console.log(error);

      //   // if (error.response) {
      //   //   // La respuesta fue hecha y el servidor respondió con un código de estado
      //   //   // que esta fuera del rango de 2xx
      //   //   console.log(error.response.data);
      //   //   console.log(error.response.status);
      //   //   console.log(error.response.headers);
      //   // } else if (error.request) {
      //   //   // La petición fue hecha pero no se recibió respuesta
      //   //   // `error.request` es una instancia de XMLHttpRequest en el navegador y una instancia de
      //   //   // http.ClientRequest en node.js
      //   //   console.log(error.request);
      //   // } else {
      //   //   // Algo paso al preparar la petición que lanzo un Error
      //   //   console.log('Error', error.message);
      //   // }
      //   // console.log(error.config);
      // });